import Vue from 'vue';
import Router from 'vue-router';
import SvgIcon from '@/components/common/svg_icon/svg';
import lazyload from '@/components/common/lazy_load';
import Toast from '@/components/common/toast';
import Loading from '@/components/common/loading';
import MessageBox from '@/components/common/message_box';
import FastClick from 'fastclick';
import RaiseMessage from '@/components/app/raise_box';
import RaiseFocusMessage from '@/components/app/raise_box_focus';
import RaisePaymentMessage from '@/components/app/raise_box_payment';
import RaiseNewPayment from '@/components/app/raise_box_new';
import RaiseAnimationPayment from '@/components/app/raise_box_animation'
import FetchLoading from '@/components/app/fetchLoading';
import RaiseImg from '@/components/app/raise_img'
import RaiseBoxRole3 from '@/components/app/raise_box_role3'
import RaiseBoxMineRedbag from '@/components/app/raise_box_mine_redbag'
import { sendLog } from '@/libs/utils/log';
import log from '@/directives/v-log';
import infiniteScroll from '@/components/common/infinite_scroll';
import Wx from '@/libs/app/weixin';
import Axios from 'axios';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import store2 from 'store2';
import router from '@/router';
import VueClipboard from 'vue-clipboard2';
import VueProgressiveImage from 'vue-progressive-image';
import PathJumpSeparation from '@/plugins/PathJumpSeparation'
// import * as Sentry from '@sentry/browser'
// import * as Integrations from '@sentry/integrations'
import store from './store';
import App from './app.vue';
import { getBootId } from '@/libs/utils/boot'
import filters from './libs/utils/filters'
import photoBottomToast from '@/components/app/photo/bottom_toast.vue'
import PhotoToastNew from '@/components/app/photo_toast_new'

Object.keys(filters).forEach((key) => { Vue.filter(key, filters[key]) })

// init boot_id
getBootId()

Vue.config.ignoredElements = ['wx-open-launch-weapp']
const isOnlineDebug = window.location.href.includes('debug');
const isStageDebug = process.env.NODE_ENV === 'stage';
if (isOnlineDebug || isStageDebug) {
  // eslint-disable-next-line
  import(
    /* webpackChunkName: "debug-chunk" */
    /* webpackMode: "lazy" */
    '@/libs/app/debug'
  );
}

// if (isProduction) {
//   Sentry.init({
//     dsn: 'http://9d629eb7e3b14993b34ba2a4b7654cf9@ktv.sentry.ktvsky.com/13',
//     integrations: [
//       new Integrations.Vue({
//         Vue,
//         attachProps: true
//       })
//     ],
//     release: process.env.SENTRY_RELEASE,
//     environment: location.host.includes('stage') ? 'stage' : 'production'
//   })
// }

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.directive('log', log);

Vue.config.productionTip = false;
Wx.captureWxEntrySignUrl();
window.addEventListener('pageshow', () => {
  Wx.syncPageUrlForWxSign()
  if (Wx.isSdkReady()) {
    store.commit('INIT_WX_CONFIG');
    Wx.checkIsFromMiniProgram((flag) => {
      store.commit('IS_MIN_PROGRAM', flag);
    });
    return
  }
  Wx.init(() => {
    store.commit('INIT_WX_CONFIG');
    Wx.checkIsFromMiniProgram((flag) => {
      store.commit('IS_MIN_PROGRAM', flag);
    });
  });
});
if (location.href.includes('appid')) { // 小程序webview没有pageshow事件
  Wx.init(() => {
    store.commit('INIT_WX_CONFIG');
    Wx.checkIsFromMiniProgram((flag) => {
      store.commit('IS_MIN_PROGRAM', flag);
    });
  });
}
Axios.defaults.baseURL = '/api'; // 解决跨域问题

// 添加fastclick
if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', () => {
    FastClick.attach(document.body);
    FastClick.prototype.focus = function (targetElement) {
      let length;
      if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
        length = targetElement.value.length;
        targetElement.focus();
        targetElement.setSelectionRange(length, length);
      } else {
        targetElement.focus();
      }
    }
  }, false);
}

// 插件
Vue.use(lazyload);
Vue.use(Router);
Vue.use(infiniteScroll);
Vue.use(require('vue-touch'), { name: 'v-touch' });

Vue.use(VueAwesomeSwiper);
Vue.use(VueProgressiveImage);
Vue.use(PathJumpSeparation, {
  router,
  store,
})

// vue全局变量
Vue.$toast = Vue.prototype.$toast = Toast;
Vue.$loading = Vue.prototype.$loading = Loading;
Vue.$messageBox = Vue.prototype.$messageBox = MessageBox;
Vue.$RaiseMessage = Vue.prototype.$RaiseMessage = RaiseMessage;
Vue.$RaiseFocusMessage = Vue.prototype.$RaiseFocusMessage = RaiseFocusMessage.install;
Vue.$RaisePaymentMessage = Vue.prototype.$RaisePaymentMessage = RaisePaymentMessage.install;
Vue.$RaiseNewPayment = Vue.prototype.$RaiseNewPayment = RaiseNewPayment.install;
Vue.$RaiseAnimationPayment = Vue.prototype.$RaiseAnimationPayment = RaiseAnimationPayment.install;
Vue.$store2 = Vue.prototype.$store2 = store2;
Vue.$sendLog = Vue.prototype.$sendLog = sendLog;
Vue.$fetchLoading = Vue.prototype.$fetchLoading = FetchLoading;
Vue.$RaiseImg = Vue.prototype.$RaiseImg = RaiseImg.install;
Vue.$RaiseBoxRole3 = Vue.prototype.$RaiseBoxRole3 = RaiseBoxRole3;
Vue.$RaiseBoxMineRedbag = Vue.prototype.$RaiseBoxMineRedbag = RaiseBoxMineRedbag;
// 组件
Vue.component(SvgIcon.name, SvgIcon);

// 注册为全局组件
Vue.component('photoBottomToast', photoBottomToast)

// 创建 PhotoToastNew 实例并添加到原型链
Vue.$photoToastNew = Vue.prototype.$photoToastNew = PhotoToastNew.install

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
